export default __webpack_public_path__ + "static/media/China03.00d950fb.obj";